import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import FleetView from "./pages/FleetView";
import FleetViewMap from "./pages/FleetViewMap";
import FuelNet from "./pages/FuelNet";
import Notification from "./pages/Notification";
import Canvas from "./pages/Canvas";
import Econet from "./pages/Econet";
import BatterynetNew from "./pages/BatterynetNew";
import SingUp from "./pages/SingUp";
import Login from "./pages/Login";
import PrivateRoute from "./PrivateRoute";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";
import DevicesList from "./pages/DevicesList";
import DigitalTwin from "./pages/DigitalTwin";
import { ConfigProvider } from "antd";
import { UseContextData } from "./context/dateContext";

function App() {
  const { isDarkTheme } = UseContextData();

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: isDarkTheme ? "#000000" : "#68DCB5",
            color: isDarkTheme ? "#000000" : "#68DCB5",
            colorBgContainer: isDarkTheme ? "#3D3D3D" : "#ffffff",
            colorText: isDarkTheme ? "#ffffff" : "#000000",
            borderRadius: 8,
            colorBgElevated: isDarkTheme ? "#3D3D3D" : "#fff", // for modals, popovers, etc.
          },
        }}
      >
        <Router>
          <Routes>
            <Route path="*" exact={true} element={<NotFound />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <FleetView />
                </PrivateRoute>
              }
            />
            <Route
              path="/fleet_view"
              element={
                <PrivateRoute>
                  <FleetView />
                </PrivateRoute>
              }
            />
            <Route
              path="/devices_list"
              element={
                <PrivateRoute>
                  <DevicesList />
                </PrivateRoute>
              }
            />
            <Route
              path="/fleet_view_map"
              element={
                <PrivateRoute>
                  <FleetViewMap />
                </PrivateRoute>
              }
            />
            <Route
              path="/fuel_net"
              element={
                <PrivateRoute>
                  <FuelNet />
                </PrivateRoute>
              }
            />

            {/* <Route
            path="/digital_twins"
            element={
              <PrivateRoute>
                <VehiclesTwins />
              </PrivateRoute>
            }
          /> */}
            <Route
              path="/digital_twins"
              element={
                <PrivateRoute>
                  <DigitalTwin />
                </PrivateRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <PrivateRoute>
                  <Notification />
                </PrivateRoute>
              }
            />
            <Route
              path="/canvas"
              element={
                <PrivateRoute>
                  <Canvas />
                </PrivateRoute>
              }
            />
            <Route
              path="/econet"
              element={
                <PrivateRoute>
                  <Econet />
                </PrivateRoute>
              }
            />
            <Route
              path="/batterynet"
              element={
                <PrivateRoute>
                  <BatterynetNew />
                </PrivateRoute>
              }
            />
            <Route path="/signup" element={<SingUp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forget-password" element={<ForgetPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          </Routes>
        </Router>
      </ConfigProvider>
    </>
  );
}

export default App;
